import { AppState } from '../../../../../redux/reducers';

export interface ContractConceptCategoryListProps {
  isOpen: boolean;
  onDismiss: () => void;
}

export const shouldLoadCategories = (
  conceptCategoryState: AppState['ConceptCategories']
): boolean => {
  return Boolean(
    conceptCategoryState &&
      !conceptCategoryState.successLoadingAll &&
      !conceptCategoryState.isLoadingAll
  );
};

export const shouldReloadCategories = (
  conceptCategoryState: AppState['ConceptCategories']
): boolean => {
  return Boolean(
    conceptCategoryState?.successAddingNewOne ||
      conceptCategoryState?.successUpdatingOne ||
      conceptCategoryState?.successDeletingOne
  );
};

